import TrancheMeta from "./TrancheMeta";
import TransactionCompanyWrapper from "./TransactionCompanyWrapper";
class TrancheMetaWrapper extends TrancheMeta {
    constructor(response) {
        super(response);
        if (response !== undefined) {
            this.parties = response.parties?.map((p) => new TransactionCompanyWrapper(p));
        }
    }
}
export default TrancheMetaWrapper;
